module.exports = __webpack_public_path__ + "img/icon-num5.37d15bd0.png";